import { IPosition } from '@shared/interfaces/iposition';
import { IIcon } from '@shared/interfaces/iicon';
import { BehaviorSubject, Observable } from 'rxjs';
import { properties } from '@env/properties.config';
import { BranchService } from '@shared/services/branch.service';
import { BranchViewModel } from '../models/branch-view.model';
import { Injectable } from '@angular/core';
import { RestaurantTypes } from '../enums/restaurant-type';

declare const google: any;

@Injectable()
export class MapsService {
  private _position: any;
  private _markers: any[] = [];
  private _map: any;
  private _markersIcon: IIcon;

  private markersBehavior: BehaviorSubject<IPosition> = new BehaviorSubject<
    IPosition
  >(null);
  public markersEmitter: Observable<
    IPosition
  > = this.markersBehavior.asObservable();

  constructor(private branchService: BranchService) { }

  changeMarker(position: IPosition): void {
    this.markersBehavior.next(position);
  }

  initMap(
    mapClassName: string,
    zoom?: number,
    position?: IPosition,
    markersIcon?: IIcon,
    markers?: any[],
    addClickEvent?: boolean,
  ): any {
    this._position = new google.maps.LatLng(
      position ? position.latitude : properties.maps.defaultLocation.latitude,
      position ? position.longitude : properties.maps.defaultLocation.longitude
    );

    this._markersIcon = markersIcon;

    const mapOptions = {
      zoom: zoom || properties.maps.zoom,
      center: this._position,
      scrollwheel: true,
      gestureHandling: 'cooperative',
      scaleControl: true
    };

    this._map = new google.maps.Map(
      document.getElementsByClassName(mapClassName)[0],
      mapOptions
    );
    this._map.panTo(this._position);

    if (markers) {
      this.addMultipleMarkers(markers);
    }

    if (markers && markers.length <= 1 && addClickEvent) {
      this._map.addListener('click', event => {
        const latLng = { lat: event.latLng.lat(), lng: event.latLng.lng() };
        this.addMarker(latLng);
      });
    } else if (markers && markers.length <= 1) {
      const latLng = { lat: position.latitude, lng: position.longitude };
      this.addMarker(latLng);
    }

    return this._map;
  }

  addMarker(position?: any): void {
    this.deleteAllMarker();
    this.paintMarker(null, position, false);
  }

  addMultipleMarkers(markers: any[]) {
    markers.forEach(markerPosition => {
      const latLng = {
        lat: markerPosition.latitude,
        lng: markerPosition.longitude,
        restaurantType: markerPosition.restaurantType,
        coverageRadius: markerPosition.coverageRadius,
        hasDelivery: markerPosition.hasDelivery
      };
      this.paintMarker(markerPosition.restaurantType, latLng, true, markerPosition.id);
    });
  }

  paintMarker(restaurantType: RestaurantTypes, position?: any, isGeneralMap?: boolean, id?: number): void {
    console.log('pMarket');
    let icon = {};
    if (this._markersIcon) {
      icon = {
        scaledSize: new google.maps.Size(32, 32),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0)
      };
      if (restaurantType !== null) {

        let urlMarker: string;
        let titleMarker: string;
        let branchColor: string;
        switch (restaurantType) {
          case RestaurantTypes.RESTAURANT:
            urlMarker = 'assets/img/marker-restaurant.png';
            titleMarker = 'Jade Restaurant';
            branchColor = '#263645';
            break;
          case RestaurantTypes.TERIYAKI:
            urlMarker = 'assets/img/marker-jade.png';
            titleMarker = 'Jade Teriyaki';
            branchColor = '#a82025';
            break;
          case RestaurantTypes.TAMASHI:
            urlMarker = 'assets/img/marker-tamashi.svg';
            titleMarker = 'Tamashi';
            branchColor = '#000000';
            break;
          case RestaurantTypes.ZENKITCHEN:
            urlMarker = 'assets/img/marker-zen-kitchen.svg';
            titleMarker = 'Zen Kitchen';
            branchColor = '#082d3f';
            break;
        }
        position.branchColor = branchColor;
        this._markersIcon.url = urlMarker;
        this._markersIcon.title = titleMarker;
      }
      icon = Object.assign(icon, this._markersIcon);
    }

    const marker = new google.maps.Marker({
      position: position,
      map: this._map,
      icon: this._markersIcon ? icon : {}
    });
    if (position.hasDelivery) {
      var circle = new google.maps.Circle({
        map: this._map,
        radius: position.coverageRadius * 1000,    // 10 miles in metres
        fillColor: position.branchColor
      });
      circle.bindTo('center', marker, 'position');
    }

    if (isGeneralMap && id) {
      const self = this;
      marker.addListener('click', function () {
        self.branchService.getById(id).then((branch) => {
          const infowindow = new google.maps.InfoWindow({
            content: self.getTemplateInfo(branch)
          });
          infowindow.open(this.map, marker);
        });
      });
    }

    this._markers.push(marker);
    this.setMarkerSizeByZoom(this._map, marker);
    this.changeMarker({
      latitude: position.lat,
      longitude: position.lng,
      restaurantType: position.restaurantType
    });
  }

  getTemplateInfo(branch: BranchViewModel): string {
    if (!branch.name) {
      return;
    }
    return `
    <div class="info-windows">
      <div class="header">${branch.name} | ${branch.branchCode}</div>
      <div class="info">${branch.address ? branch.address : ''}</div>
      <div class="info">${branch.phone ? branch.phone : ''}</div>
    </div>
    `;
  }


  deleteAllMarker(): void {
    this._markers.forEach(marker => {
      marker.setMap(null);
    });
    this._markers = [];
  }

  setMarkerSizeByZoom(map: any, marker: any) {

    function handleZoom(event) {
      const zoom = map.getZoom();
      const markerWidth = (zoom / 15) * 30;
      const markerHeight = (zoom / 15) * 30;

      marker.setIcon(
        new google.maps.MarkerImage(
          marker.getIcon().url,
          null,
          null,
          null,
          new google.maps.Size(markerWidth, markerHeight)
        )
      );

    }
    google.maps.event.addListener(map, 'zoom_changed', handleZoom);
  }
}

export const snapshotToArray = snapshot => {
  let returnArr = [];
  snapshot.forEach(childSnapshot => {
    let item = childSnapshot.val();
    item.key = childSnapshot.key;
    returnArr.push(item);
  });

  return returnArr;
};
